module.exports = __webpack_public_path__ + "img/success-trophy.68586e61.svg";